/* ====================================================================
   HELPERS —> GET CURRENT MEDIA QUERY
   ==================================================================== */

/**
 * @function getCurrentMediaQuery
 * Returns the name of the current breakpoint by looking at the
 * font-family of the head of the document or the body's pseudo contents
 *
 * Useful for running functions at specific breakpoints without declaring
 * breakpoint size information in JavaScript
 *
 * Documentation:
 * https://code.area17.com/a17/a17-helpers/wikis/getCurrentMediaQuery
 */

const getCurrentMediaQuery = () => {
  const parse = (str) => {
    return str.replace(/'/gi, '').replace(/"/gi, '');
  };

  if (window.opera) {
    return parse(window.getComputedStyle(document.body, ':after').getPropertyValue('content')) || 'large';
  } else if (window.getComputedStyle) {
    return parse(window.getComputedStyle(document.head, null).getPropertyValue('font-family')) || 'large';
  } else {
    return 'large';
  }
};

export default getCurrentMediaQuery;
